import React, { useContext } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import withForm from 'modules/common/hoc/withForm';
import * as action from '../action';
import * as c from '../constant';

function UpdateRegistry({
  info,
  createInput,
  updating,
  formData,
  onUpdateRegistry,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnUpdateRegistry = (e) => {
    e.preventDefault();
    onUpdateRegistry(_.get(info, 'id'), formData, () => {
      setModal({ isOpen: false });
      showTransaction(_.get(info, 'id'));
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnUpdateRegistry}>
        <div className="row">
          <div className="col-12 form-grousp">
            {createInput(
              { key: 'registry_number', label: 'Registry Number:' },
              { required: true, placeholder: 'registry number' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  ml-3 ">
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateRegistry.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  onUpdateRegistry: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  info: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_REGISTRY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateRegistry);
